var exports = {
  "JW": "SignalStrengthIcon.module__svg___OTA1bE",
  "wL": "SignalStrengthIcon.module__green___OTA1bE",
  "D9": "SignalStrengthIcon.module__yellow___OTA1bE",
  "T_": "SignalStrengthIcon.module__orange___OTA1bE",
  "wv": "SignalStrengthIcon.module__red___OTA1bE",
  "Xe": "SignalStrengthIcon.module__tertiary___OTA1bE",
  "cQ": "SignalStrengthIcon.module__tertiaryMuted___OTA1bE",
};

module.exports = exports;
